import { AppleIcon, LinuxIcon, WindowsIcon } from '../components/Icons.jsx';

const platforms = [
  {
    id: 'windows',
    name: 'Windows',
    note: 'Executável nativo · 64-bit',
    file: '/downloads/EtiquetandoApp-Print.exe',
    label: 'Baixar para Windows',
    Icon: WindowsIcon,
  },
  {
    id: 'linux',
    name: 'Linux',
    note: 'Binário único · amd64',
    file: '/downloads/EtiquetandoApp-Print-linux-amd64',
    label: 'Baixar para Linux',
    Icon: LinuxIcon,
  },
  {
    id: 'macos',
    name: 'macOS',
    note: 'Binário único · amd64',
    file: '/downloads/EtiquetandoApp-Print-darwin-amd64',
    label: 'Baixar para macOS',
    Icon: AppleIcon,
  },
];

export default function DownloadApp() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 tracking-[-0.04em] text-on-surface">Baixar Print Agent</h1>
        <p className="mt-2 max-w-3xl text-[11px] leading-6 text-on-surface-variant">
          Componente local que conecta o Estúdio à sua impressora. Instale uma vez e imprima direto.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {platforms.map(({ id, name, note, file, label, Icon }) => (
          <div
            key={id}
            className="flex flex-col items-center gap-5 rounded-[28px] border border-surface-container-highest bg-surface px-6 py-8 text-center shadow-[0_14px_28px_rgba(15,23,42,0.05)]"
          >
            <Icon className="h-16 w-auto text-on-surface" />
            <div>
              <h2 className="studio-uniform-title font-h3 text-h3 tracking-[-0.03em] text-on-surface">{name}</h2>
              <p className="mt-1 text-[10px] text-on-surface-variant">{note}</p>
            </div>
            <a
              href={file}
              download
              className="rounded-2xl bg-primary px-6 py-3 text-[11px] font-semibold text-on-primary shadow-[0_12px_24px_rgba(249,115,22,0.2)] transition-opacity hover:opacity-90"
            >
              {label}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
